import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import CreditCheckOrgUser from './CreditCheckOrgUser';

/**
 * CreditCheckWithOTP Component
 * 
 * This component is for credit checks WITH OTP verification.
 * 
 * Plans available:
 * - Basic: LCS Report & PAN Verification
 * - Advanced: Basic + Credit Bureau API (Equifax) WITH OTP - User Consent Required
 * - Combo: Basic + Advanced + Court Case verification
 * 
 * Uses Equifax API with OTP-based user consent flow.
 */
export default function CreditCheckWithOTP() {
  const location = useLocation();
  const [selectedPlan, setSelectedPlan] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const plan = params.get('plan');
    if (plan) {
      // Capitalize first letter for plan type
      const planType = plan.charAt(0).toUpperCase() + plan.slice(1);
      setSelectedPlan(planType);
    } else {
      setSelectedPlan(null);
    }
  }, [location.search]);

  return <CreditCheckOrgUser mode="with-otp" selectedPlan={selectedPlan} />;
}
